// extracted by mini-css-extract-plugin
export default {"question":"tZSdr","readOnlyQuestion":"vYueS","title":"FtSBG","settings":"sp_J2","divider":"xQLds","select":"AzzyJ","selectTitle":"wMDbq","commentSection":"qZswB","comment":"CkkQk"};